import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BlogListPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BLOG_API = '/api/blog.php';

function formatDate(str) {
  if (!str) return '';
  return new Date(str).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function BlogListPage() {
  const navigate = useNavigate();
  const [active,  setActive]  = useState('All');
  const [blogs,   setBlogs]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${BLOG_API}?action=list`)
      .then(r => r.json())
      .then(d => { if (d.success) setBlogs(d.rows || []); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const allCats = ['All', ...Array.from(new Set(blogs.map(b => b.category).filter(Boolean)))];
  const filtered = active === 'All' ? blogs : blogs.filter(b => b.category === active);

  return (
    <>
      <Header />
      <main className="blp-main">
        {/* Hero */}
        <div className="blp-hero">
          <p className="blp-hero-label">THE MAD MARKETING BLOG</p>
          <h1 className="blp-hero-title">
            E-Commerce Intelligence,<br />
            <span className="blp-hero-gradient">Built for Builders</span>
          </h1>
          <p className="blp-hero-sub">
            Real strategies, real case studies, and actionable insights from the team that scales brands.
          </p>
        </div>

        {/* Filter tabs */}
        <div className="blp-filters-wrap">
          <div className="blp-filters">
            {allCats.map(cat => (
              <button
                key={cat}
                className={`blp-filter-btn${active === cat ? ' blp-filter-btn--active' : ''}`}
                onClick={() => setActive(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Grid */}
        <div className="blp-grid-wrap">
          {loading ? (
            <div className="blp-loading">Loading articles…</div>
          ) : filtered.length === 0 ? (
            <div className="blp-loading">No articles found.</div>
          ) : (
            <div className="blp-grid">
              {filtered.map((post, i) => (
                <article
                  key={post.slug}
                  className={`blp-card${i === 0 && active === 'All' ? ' blp-card--hero' : ''}`}
                  onClick={() => navigate(`/blog/${post.slug}`)}
                >
                  <div className="blp-card-img-wrap">
                    <img
                      src={post.cover_image}
                      alt={post.title}
                      className="blp-card-img"
                      loading="lazy"
                    />
                    <span
                      className="blp-card-cat"
                      style={{ background: post.category_color || '#4f46e5' }}
                    >
                      {post.category}
                    </span>
                  </div>
                  <div className="blp-card-body">
                    <div className="blp-card-meta">
                      <span>{formatDate(post.published_at)}</span>
                      <span className="blp-meta-dot" />
                      <span>{post.read_time}</span>
                    </div>
                    <h2 className="blp-card-title">{post.title}</h2>
                    <p className="blp-card-excerpt">{post.excerpt}</p>
                    <span className="blp-card-link">
                      Read article
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7" />
                      </svg>
                    </span>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}
